import { render } from "./EditSensorEventModal.vue?vue&type=template&id=10875462&scoped=true"
import script from "./EditSensorEventModal.vue?vue&type=script&lang=js"
export * from "./EditSensorEventModal.vue?vue&type=script&lang=js"

import "./EditSensorEventModal.vue?vue&type=style&index=0&id=10875462&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10875462"]])

export default __exports__